import { render } from "./policyHeader.vue?vue&type=template&id=709fa3cb&scoped=true"
import script from "./policyHeader.vue?vue&type=script&lang=js"
export * from "./policyHeader.vue?vue&type=script&lang=js"

import "./policyHeader.vue?vue&type=style&index=0&id=709fa3cb&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-709fa3cb"]])

export default __exports__